import apiNonOrder from '@/api/nonOrder';
import apiOption from '@/api/option';

const defaultState = () => ({
	listNonOrder: [],
	detailNonOrder: {},
	nonOrderPagination: '',
	listProduct: [],
	listWarehouse: [],
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setNonOrder(state, data) {
		state.listNonOrder = data.data
		state.nonOrderPagination = data.pagination;
	},
	setDetailNonOrder(state, data) {
		state.detailNonOrder = data
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.quantity = 1
			return el
		});
	},
	setWarehouse(state, data) {
		state.listWarehouse = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataNonOrder(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getNonOrder({ commit }, params) {
		return new Promise((resolve) => {
			apiNonOrder.getNonOrder(params).then(({ data: { data } }) => {
				commit('setNonOrder', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setNonOrder', { data: [], pagination: {} });
			});
		});
	},
	getNonOrderAll({ commit }, params) {
		return new Promise((resolve) => {
			apiNonOrder.getNonOrderAll(params).then(({ data: { data } }) => {
				commit('setNonOrder', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setNonOrder', { data: [], pagination: {} });
			});
		});
	},
	getNonOrderWaiting({ commit }, params) {
		return new Promise((resolve) => {
			apiNonOrder.getNonOrderWaiting(params).then(({ data: { data } }) => {
				commit('setNonOrder', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setNonOrder', { data: [], pagination: {} });
			});
		});
	},
	getDetailNonOrder({ commit, dispatch }, params) {
		apiNonOrder.getDetailNonOrder(params).then(({ data: { data } }) => {
			commit('setDetailNonOrder', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailNonOrder', { data: [] });
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getOptionProduct().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getOptionWarehouse({ commit }) {
		apiOption.getOptionWarehouseAll().then(({ data: { data } }) => {
			commit('setWarehouse', data.results);
		}).catch(() => {
			commit('setWarehouse', []);
		});
	},
	async exportNonOrder({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiNonOrder.exportNonOrder(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data transaksi Non Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportNonOrderAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiNonOrder.exportNonOrderAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data transaksi Non Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createNonOrder({ commit, dispatch }, params) {
		await apiNonOrder.createNonOrder(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
	},
	async approveNonOrder({ commit, dispatch }, params) {
		await apiNonOrder.approveNonOrder(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
	},
	async cancelNonOrder({ commit, dispatch }, params) {
		await apiNonOrder.cancelNonOrder(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};